import React, { useEffect, useState } from "react";
import { Zap, Menu, X } from "lucide-react";
import { brand, nav } from "../mock";
import { Button } from "./ui/button";

const Header = ({ onBuy }) => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[#0a101e]/95 backdrop-blur border-b border-white/5 py-3"
          : "bg-transparent py-5"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 flex items-center justify-between">
        <button onClick={() => scrollTo("home")} className="flex items-center gap-3 group">
          <span className="w-10 h-10 rounded-lg bg-[#0f1a30] border border-yellow-400/30 flex items-center justify-center group-hover:border-yellow-400 transition-colors">
            <Zap className="w-5 h-5 text-yellow-400 fill-yellow-400" />
          </span>
          <span className="font-pixel text-yellow-400 text-lg tracking-wider">{brand.name}</span>
        </button>

        <nav className="hidden md:flex items-center gap-9">
          {nav.map((n) => (
            <button
              key={n.id}
              onClick={() => scrollTo(n.id)}
              className="text-slate-200 hover:text-yellow-400 text-base tracking-wide transition-colors"
            >
              {n.label}
            </button>
          ))}
        </nav>

        <div className="hidden md:block">
          <Button
            onClick={onBuy}
            className="bg-yellow-400 hover:bg-yellow-300 text-[#0a101e] font-semibold rounded-lg px-5 gap-2"
          >
            <Zap className="w-4 h-4 fill-[#0a101e]" /> Buy Now
          </Button>
        </div>

        <button className="md:hidden text-yellow-400" onClick={() => setOpen(!open)}>
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-[#0a101e] border-t border-white/5 px-5 py-4 flex flex-col gap-3">
          {nav.map((n) => (
            <button
              key={n.id}
              onClick={() => scrollTo(n.id)}
              className="text-left text-slate-200 hover:text-yellow-400 py-1"
            >
              {n.label}
            </button>
          ))}
          <Button
            onClick={() => {
              setOpen(false);
              onBuy();
            }}
            className="bg-yellow-400 hover:bg-yellow-300 text-[#0a101e] font-semibold rounded-lg gap-2 mt-1"
          >
            <Zap className="w-4 h-4 fill-[#0a101e]" /> Buy Now
          </Button>
        </div>
      )}
    </header>
  );
};

export default Header;
